export default __webpack_public_path__ + "static/media/logo.0859fca3.svg";